const getTreeStructureSettings = (structureFlat) => {
  const mutableAccessories = structureFlat.map((accessory) => ({
    ...accessory,
    accessories: [],
  }));

  const roots = mutableAccessories.filter((accessory) => !accessory.parentId);

  const assignChildren = (parent) => {
    // eslint-disable-next-line no-param-reassign
    parent.accessories = mutableAccessories
      .filter((accessory) => accessory.parentId === parent.id);

    parent.accessories.forEach((accessory) => {
      assignChildren(accessory);
    });
  };

  roots.forEach((root) => {
    assignChildren(root);
  });

  return roots;
};

export default getTreeStructureSettings;
